export default function linkClear(str) {
    return str.replace('/', '-')
}
